export enum AppMenuLevelEnum {
  ROOT,
  PACKAGE,
  MODULE
}
